import React from 'react';
import { IEditorProps } from './props-interfaces';
import { Uploader } from './uploader';

export const BinaryFileEditor = (props: IEditorProps) => <Uploader {...props} />